/**
======================================
FMP Soluções - Novo site 
======================================

Códigos em excesso removidos
Footer é chamado FMPFooter
Navbar ainda é a default porque eu não consegui desatrelar tudo

*/

// @mui material components
import Icon from "@mui/material/Icon";

// ------------------------------------------
// -------------- Pages ---------------------
// ------------------------------------------

//Empresa
import SobreNos from "layouts/pages/empresa/sobre-nos";
import NoticiasNossas from "layouts/pages/empresa/noticias";
import Privacidade from "layouts/pages/empresa/politica-privacidade";
//import Termos from "layouts/pages/empresa/termos-condicoes";
//import Jobs from "layouts/pages/empresa/carreiras";

//Academia Cyber
import AcademiaCiber from "layouts/pages/academia-ciber";
import Treinamento from "layouts/pages/academia-ciber/treinamento";
import ICEMBA from "layouts/pages/academia-ciber/icemba";

//Produtos
import Produtos from "layouts/pages/produtos";
import Templar from "layouts/pages/produtos/templar";
import Licencas from "layouts/pages/produtos/licencas";
import RevBits from "layouts/pages/produtos/licencas/RevBits";

//Servicos
import Servicos from "layouts/pages/servicos";
import Consultoria from "layouts/pages/servicos/consultoria";
import Penetration from "layouts/pages/servicos/penetration-test";
import SOC from "layouts/pages/servicos/soc";

//Ajuda
//import Suporte from "layouts/pages/ajuda/suporte";
import FAQ from "layouts/pages/ajuda/faq";
import ContateNos from "layouts/pages/ajuda/contate-nos";


//Centro de Excelencia
import CentroExcelencia from "layouts/pages/centro-de-excelencia";
import ExcelenciaProjetos from "layouts/pages/centro-de-excelencia/projetos";
import Parceiros from "pages/Empresa/SobreNos/sections/Parceiros";


//import ContactUs from "layouts/pages/ajuda/contact-us";


const routes = [
  {
    route: "/pages/academia-ciber",
    component: <AcademiaCiber />,
  },
  {
    route: "/pages/servicos",
    component: <Servicos />,
  },
  {
    route: "/pages/centro-de-excelencia",
    component: <CentroExcelencia />,
  },
  {        route: "/pages/produtos",
        component: <Produtos />,
  },
  {
    name: "Menu",
    icon: <Icon>dashboard</Icon>,
    columns: 3,
    rowsPerColumn: 2,
    collapse: [
      {
        name: "Empresa",
        collapse: [
          {
            name: "Sobre nós",
            route: "/pages/empresa/sobre-nos",
            component: <SobreNos />,
          },
          {
            name: "Noticias",
            route: "/pages/empresa/noticias",
            component: <NoticiasNossas />,
          },
          /*
          {
            name: "Parceiros",
            route: "/pages/empresa/parceiros",
            component: <Parceiros />,
          },
          */
          {
            name: "politica de privacidade",
            route: "/pages/empresa/politica-privacidade",
            component: <Privacidade />,
          },
        ],
      },
      {
        name: "Produtos",
        collapse: [
          {
            name: "Templar",
            route: "/pages/produtos/templar",
            component: <Templar />,
          },
          {
            name: "Software",
            route: "/pages/produtos/licencas",
            component: <Licencas />,
          },
          {
            name: "RevBits",
            route: "/pages/produtos/licencas/RevBits",
            component: <RevBits />,
          },
        ],
      },
      {
        name: "Servicos",
        collapse: [
          {
            name: "Consultoria Cyber",
            route: "/pages/servicos/consultoria",
            component: <Consultoria />,
          },
          {
            name: "Teste de Penetracao",
            route: "/pages/servicos/penetration-test",
            component: <Penetration />,
          },
          {
            name: "SOC",
            route: "/pages/servicos/soc",
            component: <SOC />,
          },
        ],
      },
      {
        name: "Academia Cyber",
        collapse: [
          {
            name: "Treinamento",
            route: "/pages/academia-ciber/treinamento",
            component: <Treinamento />,
          },
          {
            name: "ICEMBA",
            route: "/pages/academia-ciber/icemba",
            component: <ICEMBA />,
          },
        ],
      },
      {
        name: "Centro de Excelencia",
        collapse: [
          {
            name: "Projetos",
            route: "/pages/centro-de-excelencia/projetos",
            component: <ExcelenciaProjetos />,
          },
        ],
      },
      {
        name: "Ajuda",
        collapse: [
          {
            name: "Perguntas frequentes",
            route: "/pages/ajuda/faq",
            component: <FAQ />,
          },
          {
            name: "Contato",
            route: "/pages/ajuda/contate-nos",
            component: <ContateNos />,
          },
        ],
      },  
    ],
    
  },
];


export default routes;
